var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import Icon from "../Icon";
var Svg = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var FinanceLogo = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "#E2665C" : _b, _c = _a.width, width = _c === void 0 ? 36 : _c, _d = _a.height, height = _d === void 0 ? 36 : _d, className = _a.className;
    return (React.createElement("div", { style: { width: width, height: height }, className: className },
        React.createElement(Svg, { viewBox: "0 0 36 36" },
            React.createElement("path", { fill: color, d: "M16.8526 16.2795L0 8.04188V0L16.8526 8.23763V16.2795ZM18.4443 16.2795L35.297 8.04188V0L18.4443 8.23763V16.2795ZM18.4443 26.164L35.297 17.9263V9.88395L18.4443 18.1216V26.164ZM18.4443 36V27.9576L26.8703 23.8385L18.4443 36ZM0 17.9263L16.8526 26.164V18.1216L0 9.88395V17.9263ZM16.8522 27.9576V36L8.4261 23.8385L16.8522 27.9576Z" }))));
};
var templateObject_1;
